import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';

import Button from '../../forms/Button/Button';
import { GET_STARTED } from '../../../routes/paths';

import styles from './styles.module.scss';
import { useLocalizedPath } from '../../../seo/useLocalizedPath';

const MainSection = () => {
  const { t } = useTranslation();
  const localizePath = useLocalizedPath();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  const sliderItem1 = (
    <div className={`${styles.infoWrapper} ${styles.bg1}`}>
      <div className={styles.content}>
        <div className={styles.wrapper}>
          <h2>#1 {t('realGrassDogPotty')}</h2>
          <p>{t('soldPatchesTxt')}</p>
          <Link to={localizePath(GET_STARTED)}>
            <Button className={styles.mainButton}>{t('orderNow')}</Button>
          </Link>
        </div>
      </div>
    </div>
  );

  const sliderItem2 = (
    <div className={`${styles.infoWrapper} ${styles.bg2}`}>
      <div className={styles.content}>
        <div className={styles.wrapper}>
          <h2>#1 {t('realCatGrass')}</h2>
          <p>{t('realCatGrassDesc')}</p>
          <Link to={localizePath('/products/catnip/standard')}>
            <Button className={styles.mainButton}>{t('orderNow')}</Button>
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles.mainSection}>
      <Slider {...settings}>
        {sliderItem1}
        {sliderItem2}
      </Slider>
    </div>
  );
};

export default MainSection;
